import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {RoadKill} from "../RoadKill";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {TimelineLite} from "gsap";
import {RoadKillGameAssets} from "../RoadKillGameAssets";
import {Multiplier} from "../component/Multiplier";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {RoadKillSound} from "../sound/RoadKillSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";


export class RoadKillBackgroundElements extends PIXI.Container implements StageLayer {
    private _behindMultiAnim: TimelineSprite;
    private _multiplier: Multiplier;
    private _gameLogo: PIXI.Sprite;
    private _billyTyre: PIXI.Sprite[] = [];
    private _hillyTyre: PIXI.Sprite;
    private _speechBubbleContainer: PIXI.Container;
    private _hillySpeechBubbleWithTyre: PIXI.Container;
    private _billySpeechBubbleWithTyre: PIXI.Container;
    private TYRE_SCALED_DOWN: number = 0.8
    private SPEECH_HILLY_BILLY_SCALED_DOWN: number = 0.6;
    private SCALING_FACTOR: number = 0.9;
    private _hillyActivated: boolean = false;
    private _billyActivated: boolean = false;

    constructor() {
        super();
        this.name = "BackgroundElements";
        this.init();
    }

    get hillyActive(): boolean {
        return this._hillyActivated;
    }

    get billyActive(): boolean {
        return this._billyActivated;
    }

    private _billyBubble: PIXI.Sprite;

    get billyBubble(): PIXI.Sprite {
        return this._billyBubble;
    }


    private _hillyBubble: PIXI.Sprite;

    get hillyBubble(): PIXI.Sprite {
        return this._hillyBubble;
    }

    private _animalContainer: PIXI.Container;

    get animalContainer(): PIXI.Container {
        return this._animalContainer;
    }


    public popInHilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._hillyTyre.alpha = 0;
                this._hillyBubble.alpha = 0;
                this._hillyTyre.visible = true;
                this._hillyBubble.visible = true;
            }
        });
        this._hillyActivated = true;
        tl.to(this._hillyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to(this._hillyTyre.scale, {
            x: this.TYRE_SCALED_DOWN,
            y: this.TYRE_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._hillyBubble, this._hillyTyre], {
            alpha: 1,
            duration: 0.02
        }, 0);
        return tl;
    }

    public disableHilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this._hillyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
            duration: 0.2
        }, 0);
        tl.to(this._hillyTyre.scale, {
            x: 0,
            y: 0,
            duration: 0.2
        }, 0);
        tl.to([this._hillyBubble, this._hillyTyre], {
            alpha: 0.75,
            duration: 0.2
        }, 0);
        return tl;
    }

    public activateHilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this._hillyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN, ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to(this._hillyTyre.scale, {
            x: this.TYRE_SCALED_DOWN,
            y: this.TYRE_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._hillyBubble, this._hillyTyre], {
            alpha: 1,
            duration: 0.2
        }, 0);
        return tl;
    }

    public activateBilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this._billyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._billyTyre[0].scale, this._billyTyre[1].scale], {
            x: this.TYRE_SCALED_DOWN,
            y: this.TYRE_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._billyBubble, this._billyTyre[0], this._billyTyre[1]], {
            alpha: 1,
            duration: 0.2
        }, 0);
        return tl;
    }

    public popOutHilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._hillyTyre.visible = false;
                this._hillyBubble.visible = false;
            }
        });
        this._hillyActivated = false;
        tl.to([this._hillyTyre.scale, this._hillyBubble.scale], {
            x: 0,
            y: 0,
            alpha: 0,
            duration: 0.2
        }, 0);
        return tl;
    }

    public popOutBilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._billyBubble.visible = false;
                this._billyTyre[0].visible = false;
                this._billyTyre[1].visible = false;
            }
        });
        this._billyActivated = false;
        tl.to([this._billyBubble.scale, this._billyTyre[0].scale, this._billyTyre[1].scale], {
            x: 0,
            y: 0,
            alpha: 0,
            duration: 0.2
        }, 0);
        return tl;
    }

    public disableBillyTyres(hitPoint: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (hitPoint === 0) {
            tl.to(this._billyBubble.scale, {
                x: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
                y: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
                duration: 0.2
            }, 0);
            tl.to([this._billyTyre[0].scale, this._billyTyre[1].scale], {
                x: 0,
                y: 0,
                duration: 0.2
            }, 0)
            tl.to([this._billyBubble, this._billyTyre[0], this._billyTyre[1]], {
                alpha: 0.75,
                duration: 0.2
            }, 0);
        } else if (hitPoint === 1) {
            tl.to([this._billyTyre[0].scale], {
                x: 0,
                y: 0,
                duration: 0.2
            }, 0)
        }
        return tl;
    }

    public billyIdleState(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._billyActivated = true;
        tl.to(this._billyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN * this.SCALING_FACTOR,
            duration: 0.2
        }, 0);
        tl.to([this._billyTyre[0].scale, this._billyTyre[1].scale], {
            x: 0,
            y: 0,
            duration: 0.2
        }, 0)
        tl.to([this._billyBubble, this._billyTyre[0], this._billyTyre[1]], {
            alpha: 0.75,
            duration: 0.2
        }, 0);
        return tl;
    }

    public popInBilly(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._billyTyre[0].alpha = 0;
                this._billyTyre[1].alpha = 0;
                this._billyBubble.alpha = 0;
                this._billyTyre[0].visible = true;
                this._billyTyre[1].visible = true;
                this._billyBubble.visible = true;
            }
        });
        this._billyActivated = true;
        tl.to(this._billyBubble.scale, {
            x: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            y: this.SPEECH_HILLY_BILLY_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._billyTyre[0].scale, this._billyTyre[1].scale], {
            x: this.TYRE_SCALED_DOWN,
            y: this.TYRE_SCALED_DOWN,
            ease: "bounce.out",
            duration: 0.2
        }, 0);
        tl.to([this._billyBubble, this._billyTyre[0], this._billyTyre[1]], {
            alpha: 1,
            duration: 0.2
        }, 0);
        return tl;
    }

    public onResize() {
        if (NolimitApplication.isLandscape) {
            this._gameLogo.position.set(-152, 91);
            this.setSpeechBubblePosition(true);
        } else {
            this._gameLogo.position.set(360, -150);
            this.setSpeechBubblePosition(false);
        }
    }

    public transitionNormalToSFS(animName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                RoadKill.backgroundSpine.changeBackground(RoadKill.model.gameData.nextMode);
            }
        });
        tl.add(RoadKill.backgroundSpine.playTransitionAnim(animName, RoadKill.model.nextMode === RoadKillGameMode.SUPER_FREESPIN), 0);

        if (RoadKill.model.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            tl.add(() => {
                RoadKillUtils.fsTransition(0.75, true, RoadKill.jumpingWildView, true);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.reelView);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.initialWinView);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.bigWinView);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.topAnimalCounterView);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.winCapView);
                RoadKillUtils.fsTransition(0.75, true, this);
                RoadKillUtils.fsTransition(0.75, true, RoadKill.lifeView);
                RoadKill.soundPlayer.playTrack(RoadKillSound.MAIN_TO_SFS_TRASITION)
            }, RoadKill.backgroundSpine.bgSpine.skeleton.data.findAnimation("SfsToMain").duration - 0.60);
        }
        tl.add(() => {
            RoadKill.jumpingWildView.position.x = -3;
        })
        return tl;
    }

    public updateMultiplier(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            value = value > 5 ? 5 : value;
            this._multiplier.value = value;
            this._multiplier.visible = (this._multiplier.value >= 2);
        }, 0)
        return tl;
    }

    public addMultiplier(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            multiplerVal: number = this._multiplier.value;
        tl.add(() => {
            this._multiplier.value += value;
            this._multiplier.visible = (this._multiplier.value >= 2);
        }, 0)
        if (multiplerVal + value >= 2) {
            tl.add(this.playPersistentMultiplerSound(), 0);
        }
        return tl;
    }

    public getMultiplierValue(): number {
        return this._multiplier.value;
    }

    public playMultiplierAnim(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
                onStart: () => {
                    this._behindMultiAnim.visible = true;
                }
            }),
            animDur: number = this._behindMultiAnim.getAnimationAutoShowHide(true, true).duration();
        tl.add(this._behindMultiAnim.getAnimation()).add(() => {
            this._behindMultiAnim.visible = false;
        });
        tl.to(this._multiplier.scale, {x: 0.8, y: 0.8, duration: 0.01}, 0.5);
        tl.to(this._multiplier.scale, {x: 1.8, y: 1.8, duration: 0.066}, 0.6);
        tl.to(this._multiplier.scale, {x: 1, y: 1, duration: 0.43}, ">");
        return tl;
    }

    public playPersistentMultiplerSound(): TimelineLite {
        return new TimelineLite().add(() => {
            RoadKill.soundPlayer.playTrack(RoadKillSound.PERSISTENT_MULTIPLIER);
        })
    }

    private animateTyreElement(ele: PIXI.Sprite): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                ele.visible = false;
            }
        });
        tl.to(ele.scale, {x: 1, y: 1, duration: 0.05})
        tl.to(ele.scale, {x: this.TYRE_SCALED_DOWN, y: this.TYRE_SCALED_DOWN, duration: 0.05})
        tl.to(ele.scale, {x: 1, y: 1, duration: 0.05})
        tl.to(ele.scale, {x: 0, y: 0, duration: 0.05})
        return tl;
    }

    private setSpeechBubblePosition(isLandscapeMode: boolean): void {
        if (isLandscapeMode) {
            this._speechBubbleContainer.position.set(0, -10)
            this._billySpeechBubbleWithTyre.position.x = -5;
        } else {
            this._speechBubbleContainer.position.set(-200, -250)
            this._billySpeechBubbleWithTyre.position.x = -600;
        }
    }

    private createAnimalContaier(): void {
        this._animalContainer = new PIXI.Container();
        this._animalContainer.name = "AnimalContainer";
        this.addChild(this._animalContainer);
        this._animalContainer.position.set(0, 66);
    }

    private init() {
        this.createGameLogo();
        this.createAnimalContaier();
        this.createBehindMultiAnim();
        this.createMultiplier();
        this._hillyBubble = this.createHillyBillyBubble(true, new PIXI.Point(780, 70))
        this._billyBubble = this.createHillyBillyBubble(false, new PIXI.Point(920, 70))
        this.createHillyTyre();
        this.createBillyTyre();
        this.createSpeechBubbleContainer();
        this.onResize();
    }

    private createBehindMultiAnim(): void {
        this._behindMultiAnim = new TimelineSprite(RoadKill.assetLoader.getTextures("behindMulti"));
        this._behindMultiAnim.visible = false;
        this._behindMultiAnim.anchor.set(0.5);
        this._behindMultiAnim.position.set(644, 71);
        this.addChild(this._behindMultiAnim);
    }

    private createSpeechBubbleContainer(): void {
        this._speechBubbleContainer = new PIXI.Container();

        this._hillySpeechBubbleWithTyre = new PIXI.Container();
        this._hillySpeechBubbleWithTyre.addChild(this._hillyBubble, this._hillyTyre);
        this._hillySpeechBubbleWithTyre.name = "hillyBubbleWithTyre";

        this._billySpeechBubbleWithTyre = new PIXI.Container();
        this._billySpeechBubbleWithTyre.position.x -= 5;
        this._billySpeechBubbleWithTyre.addChild(this._billyBubble, this._billyTyre[0], this._billyTyre[1]);
        this._billySpeechBubbleWithTyre.name = "billyBubbleWithTyre";

        this._speechBubbleContainer.addChild(this._hillySpeechBubbleWithTyre, this._billySpeechBubbleWithTyre);
        this._speechBubbleContainer.name = "speechBubbleContainer";
        this._speechBubbleContainer.position.y = -10;
        this.addChild(this._speechBubbleContainer);
    }

    private createHillyTyre(): void {
        this._hillyTyre = this.createTyre(new PIXI.Point(837, 70));
        this._hillyTyre.name = "hillyTyre";
    }

    private createTyre(pos: PIXI.Point): PIXI.Sprite {
        const sprite = new PIXI.Sprite(RoadKill.assetLoader.getTextures("tyreBubbles")[0]);
        sprite.position.set(pos.x, pos.y);
        sprite.anchor.set(0.5);
        sprite.scale.set(this.TYRE_SCALED_DOWN);
        sprite.visible = false;
        return sprite;
    }

    private createBillyTyre(): void {
        this._billyTyre.push(this.createTyre(new PIXI.Point(982, 48)));
        this._billyTyre[0].name = "billyTyre1";
        this._billyTyre.push(this.createTyre(new PIXI.Point(982, 100)));
        this._billyTyre[1].name = "billyTyre2";
    }

    private createHillyBillyBubble(hilly: boolean, pos: PIXI.Point): PIXI.Sprite {
        const sprite = new PIXI.Sprite(RoadKill.assetLoader.getTextures(hilly ? "hillyBubble" : "billyBubble")[0]);
        sprite.position = pos;
        sprite.visible = false;
        sprite.anchor.set(0.5);
        sprite.scale.set(this.SPEECH_HILLY_BILLY_SCALED_DOWN);
        sprite.name = hilly ? "hillyBubble" : "billyBubble";
        return sprite
    }

    private createGameLogo(): void {
        this._gameLogo = new PIXI.Sprite(RoadKill.assetLoader.getTextures("gameLogo")[0]);
        this._gameLogo.anchor.set(0.5);
        this._gameLogo.position.set(-170, 70);
        this._gameLogo.scale.set(0.8);
        this.addChild(this._gameLogo);
    }

    private createMultiplier(): void {
        this._multiplier = new Multiplier(RoadKillGameAssets.BITMAP_FONT_NUMBERS_MULTIPLIER, 32, "x");
        this.addChild(this._multiplier);
        this._multiplier.showIfDefaultValue = true;
        this._multiplier.position.set(630, 70); //#126
        this.updateMultiplier(1);
    }
}